import styled from 'styled-components';
import ExpandIcon from '../../../../Assets/Icons/expand-more.png';

export const StyledInput = styled.input`
    width: ${props => (props.size ? '157px' : '100%')};
    height: 40px;
    padding-left: 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;

    font-size: 16px;
    color: #fff;
    border: none;
    outline: none;

    &:placeholder {
        font-size: 16px;
        color: #c5cacf;
    }
`;

export const StyledInputBackground = styled.div`
    width: 350px;
    height: 40px;
    padding-left: 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;

    border: none;
    outline: none;
    cursor: pointer;

    display: flex;
    align-items: center;
`;

export const StyledLabel = styled.label`
    font-size: 16px;
    font-weight: bold;
    color: #c5cacf;
    margin-bottom: 10px;
    display: block;
`;

export const StyledTextArea = styled.textarea`
    width: ${props => (props.width ? props.width : '350px')};
    height: 136px;
    padding: 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;

    font-size: 16px;
    color: #fff;
    border: none;
    outline: none;

    resize: none;

    &:placeholder {
        font-size: 15px;
        color: #c5cacf;
        font-weight: 300;
    }
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox ' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

export const StyledCheckbox = styled.div`
    display: inline-block;
    width: 16px;
    height: 16px;
    background: ${props => (props.checked ? 'salmon' : 'papayawhip')};
    border-radius: 3px;
    transition: all 150ms;
`;

export const CheckboxContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
`;

export const CheckboxLabel = styled.label`
    color: #c5cacf;
    margin-left: 13px;
    font-weight: 100;
    font-size: 14px;
`;

export const SelectContainer = styled.div`
    width: ${props => (props.size ? '157px' : '100%')};
    height: 40px;
    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;
`;

export const StyledSelect = styled.select`
    width: ${props => (props.size ? '157px' : '100%')};
    height: 40px;
    padding-left: 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;

    font-size: 16px;
    font-weight: 300;
    color: #fff;
    border: none;
    outline: none;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    background: url(${ExpandIcon});
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 5%;
`;

export const ErrorMessageBox = styled.p`
    width: ${props => props.width};
    text-align: ${props => (props.align ? props.align : null)};
    margin-top: 5px;
    color: #fc3d40;
    font-weight: 300;
    font-size: 13px;
    word-wrap: break-word;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/CreateEditInput/style.js